import { render, staticRenderFns } from "./_Home.vue?vue&type=template&id=235b46f1&scoped=true"
import script from "./_Home.vue?vue&type=script&lang=js"
export * from "./_Home.vue?vue&type=script&lang=js"
import style0 from "./_Home.vue?vue&type=style&index=0&id=235b46f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b46f1",
  null
  
)

export default component.exports